var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"display":"flex","margin-top":"10px"}},_vm._l((_vm.first5),function(it){return _c('div',{key:it.code,staticStyle:{"flex-grow":"1","padding":"0 5px"}},[_c('item',{attrs:{"profile":it}},[_vm._v("\n      "+_vm._s(it)+"\n    ")])],1)}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-41197234","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/screen28896/disease-zone/index.vue
// module id = null
// module chunks = 